module.exports = __webpack_public_path__ + "img/zhizzImg.e0988215.png";